export const LIMIT_PER_PAGE = 10;
export const AWS_APPSYNC_AUTHENTICATION_TYPE = "AMAZON_COGNITO_USER_POOLS";
